/*
 * fk-search.js — eigen zoekdropdown op basis van search-manticore, in de bestaande HYPER-opmaak.
 *
 * - Leeg zoekveld:  "Recent gezocht" (localStorage) + "Populair" (/popular) als chips
 * - Tijdens typen:  "Zoek naar …" + geschiedenis die past + zoeksuggesties (populair, aangevuld met
 *                   categorienamen). Categorieën en producten staan op de zoekpagina.
 * - Zoekdienst traag (> TIMEOUT) of fout: terug naar de gewone Shopify-dropdown
 *
 * Aan/uit:  ?fksearch=1 zet het aan in deze browser, ?fksearch=0 weer uit.
 *           FkSearchConfig.enabledForAll = true zet het aan voor iedereen.
 *
 * - Zoekpagina:     categorieën → verfijnen → producten in onze volgorde, kaarten via
 *                   sections/fk-search-cards.liquid, "Meer laden" per 20. Filters en sortering via
 *                   HYPER's filterdrawer, resultaten en aantallen uit onze index.
 *
 * Config komt uit snippets/fk-search.liquid (window.FkSearchConfig).
 * Haakt in op PredictiveSearch uit assets/search.js zonder dat bestand aan te passen.
 */
(function () {
  'use strict';

  var C = window.FkSearchConfig;
  if (!C || !window.customElements) return;

  // ---------------------------------------------------------------- aan/uit
  var params = new URLSearchParams(location.search);
  try {
    if (params.get('fksearch') === '1') localStorage.setItem('fkSearch', '1');
    if (params.get('fksearch') === '0') localStorage.removeItem('fkSearch');
  } catch (e) {}
  var enabled = !!C.enabledForAll;
  try { enabled = enabled || localStorage.getItem('fkSearch') === '1'; } catch (e) {}
  if (!enabled) return;

  var TIMEOUT = C.timeout || 1500;
  var HISTORY_KEY = 'fkSearchHistory';
  var HISTORY_MAX = 8;

  var LABELS = {
    nl: { more: 'Meer laden', results: '%n resultaten', shown: '%a van %b', related: 'Verfijn je zoekopdracht',
          recent: 'Recent gezocht', clear: 'Wissen', suggestions: 'Zoeksuggesties', collections: 'Categorieën',
          products: 'Producten', searchFor: 'Zoek naar %s', noResults: 'Geen resultaten voor "%s"',
          noResultsHint: 'Controleer de spelling of probeer een ander woord.',
          noFilterResults: 'Geen producten met deze filters. Haal een filter weg.' },
    de: { more: 'Mehr laden', results: '%n Ergebnisse', shown: '%a von %b', related: 'Suche verfeinern',
          recent: 'Zuletzt gesucht', clear: 'Löschen', suggestions: 'Suchvorschläge', collections: 'Kategorien',
          products: 'Produkte', searchFor: 'Suche nach %s', noResults: 'Keine Ergebnisse für „%s“',
          noResultsHint: 'Prüfe die Schreibweise oder versuche ein anderes Wort.',
          noFilterResults: 'Keine Produkte mit diesen Filtern. Entferne einen Filter.' },
    fr: { more: 'Voir plus', results: '%n résultats', shown: '%a sur %b', related: 'Affiner la recherche',
          recent: 'Recherches récentes', clear: 'Effacer', suggestions: 'Suggestions', collections: 'Catégories',
          products: 'Produits', searchFor: 'Rechercher %s', noResults: 'Aucun résultat pour « %s »',
          noResultsHint: 'Vérifiez l’orthographe ou essayez un autre mot.',
          noFilterResults: 'Aucun produit avec ces filtres. Retirez un filtre.' },
    en: { more: 'Load more', results: '%n results', shown: '%a of %b', related: 'Refine your search',
          recent: 'Recent searches', clear: 'Clear', suggestions: 'Suggestions', collections: 'Categories',
          products: 'Products', searchFor: 'Search for %s', noResults: 'No results for "%s"',
          noResultsHint: 'Check the spelling or try another word.',
          noFilterResults: 'No products with these filters. Remove a filter.' }
  };
  var L = LABELS[C.locale] || LABELS.nl;

  var ICON_SEARCH = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M10.9609 10.9636L13.9985 14.0012" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_CLOCK = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M8 4.75V8L10.25 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // ---------------------------------------------------------------- hulpjes
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(q) { return String(q || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function base() { return String(C.root || '/').replace(/\/$/, ''); }
  function searchHref(q) {
    return C.searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q);
  }
  function fmt(tpl, q) { return esc(tpl).replace('%s', '<b>' + esc(q) + '</b>'); }

  function getJSON(url, ms) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms);
    return fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) {
        clearTimeout(timer);
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .catch(function (e) { clearTimeout(timer); throw e; });
  }

  // ---------------------------------------------------------------- geschiedenis
  function getHistory() {
    try {
      var h = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      return Array.isArray(h) ? h : [];
    } catch (e) { return []; }
  }
  function addHistory(q) {
    q = norm(q);
    if (q.length < 2) return;
    var h = getHistory().filter(function (x) { return x !== q; });
    h.unshift(q);
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(h.slice(0, HISTORY_MAX))); } catch (e) {}
  }
  function clearHistory() { try { localStorage.removeItem(HISTORY_KEY); } catch (e) {} }
  function inHistory(q) { return getHistory().indexOf(norm(q)) !== -1; }

  // ---------------------------------------------------------------- populair
  var popularPromise = null;
  function getPopular() {
    if (popularPromise) return popularPromise;
    var key = 'fkPopular:' + C.store + ':' + C.locale;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.t < 30 * 60 * 1000) {
        popularPromise = Promise.resolve(cached.q);
        return popularPromise;
      }
    } catch (e) {}
    var url = C.endpoint + '/popular?store=' + encodeURIComponent(C.store) + '&locale=' + encodeURIComponent(C.locale) +
      '&limit=' + (C.popular || 12);
    popularPromise = getJSON(url, TIMEOUT).then(function (data) {
      var q = (data && data.queries) || [];
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), q: q })); } catch (e) {}
      return q;
    }).catch(function () { popularPromise = null; return null; });
    return popularPromise;
  }

  // ---------------------------------------------------------------- leeg zoekveld
  // Zoektermen altijd in kleine letters, zoals iemand ze typt (Temu-stijl); categorieën houden hun titel
  function chip(q, label, history) {
    return '<li><a href="' + esc(searchHref(q)) + '" class="ps-chip fk-chip' + (history ? ' fk-chip--history' : '') +
      '" data-fk-query="' + esc(q) + '">' + (history ? ICON_CLOCK : ICON_SEARCH) + '<span>' + esc(norm(q)) + '</span></a></li>';
  }

  function fillDefault(el) {
    var box = el.querySelector('.search__most-searched-keywords');
    if (!box) return;

    // Recent gezocht: eigen blok boven "populair"
    var recent = el.querySelector('.fk-recent');
    var history = getHistory();
    if (history.length) {
      if (!recent) {
        recent = document.createElement('div');
        recent.className = 'search__most-searched-keywords fk-recent flex flex-col gap-3';
        box.parentNode.insertBefore(recent, box);
      }
      recent.innerHTML = '<div class="fk-recent__head"><h4 class="h6">' + esc(L.recent) + '</h4>' +
        '<button type="button" class="fk-recent__clear">' + esc(L.clear) + '</button></div>' +
        '<ul class="ps-chips">' + history.map(function (q) { return chip(q, q, true); }).join('') + '</ul>';
    } else if (recent) {
      recent.remove();
    }

    // Populair: de vaste lijst uit de theme vervangen door /popular (blijft staan als dat mislukt)
    if (box.dataset.fkPopular === 'done') return;
    getPopular().then(function (items) {
      if (!items || !items.length) return;
      var ul = box.querySelector('ul.ps-chips');
      if (!ul) return;
      ul.innerHTML = items.map(function (it) { return chip(it.query, it.label, inHistory(it.query)); }).join('');
      box.dataset.fkPopular = 'done';
    });
  }

  // ---------------------------------------------------------------- resultaten
  function highlight(label, typed) {
    label = String(label || '');
    label = label.toLowerCase();
    var t = norm(typed);
    if (t && label.toLowerCase().indexOf(t) === 0) {
      return esc(label.slice(0, t.length)) + '<b>' + esc(label.slice(t.length)) + '</b>';
    }
    return esc(label);
  }

  // Tijdens typen: alleen geschiedenis + zoeksuggesties (zoals Temu). De resultaten zelf
  // (categorieën, verfijnen, producten) staan op de zoekpagina.
  function historyMatches(typed) {
    var words = norm(typed).split(' ').filter(Boolean);
    if (!words.length) return [];
    return getHistory().filter(function (h) {
      var hw = h.split(' ');
      return words.every(function (w, i) {
        return hw.some(function (x) { return x === w || (i === words.length - 1 && x.indexOf(w) === 0); });
      });
    });
  }

  function suggestionRow(query, label, typed, history, i) {
    return '<li id="predictive-search-option-query-' + i + '" role="option" aria-selected="false">' +
      '<a href="' + esc(searchHref(query)) + '" class="fk-suggestion' + (history ? ' fk-query--history' : '') +
      '" data-fk-query="' + esc(query) + '">' + (history ? ICON_CLOCK : ICON_SEARCH) +
      '<span>' + highlight(label, typed) + '</span></a></li>';
  }

  function renderResults(data, typed) {
    var max = C.queries || 8;
    var rows = [];
    var seen = {};
    var t = norm(typed);
    seen[t] = true;

    // 1. Eigen geschiedenis die bij het getypte past (max. 3)
    historyMatches(typed).slice(0, 3).forEach(function (h) {
      if (seen[h]) return;
      seen[h] = true;
      rows.push([h, h, true]);
    });
    // 2. Suggesties van de zoekdienst (populaire zoekopdrachten, aangevuld met categorienamen)
    (data.queries || []).forEach(function (q) {
      if (rows.length >= max || seen[q.query]) return;
      seen[q.query] = true;
      rows.push([q.query, q.query, inHistory(q.query)]);
    });

    // Bovenaan altijd: zoeken op precies wat er getypt is
    var html = '<div class="ps-results flex w-full flex-col">' +
      '<div class="predictive-search-result predictive-search-result--queries">' +
      '<ul class="fk-suggestions" role="group">' +
      '<li id="predictive-search-option-query-0" role="option" aria-selected="false">' +
      '<a href="' + esc(searchHref(typed)) + '" class="fk-suggestion fk-suggestion--typed" data-fk-query="' +
      esc(t) + '">' + ICON_SEARCH + '<span>' + fmt(L.searchFor, typed) + '</span></a></li>';
    rows.forEach(function (r, i) { html += suggestionRow(r[0], r[1], typed, r[2], i + 1); });
    return html + '</ul></div></div>';
  }

  function suggestUrl(q) {
    return C.endpoint + '/suggest?q=' + encodeURIComponent(q) +
      '&locale=' + encodeURIComponent(C.locale) +
      '&country=' + encodeURIComponent(C.country || '') +
      '&store=' + encodeURIComponent(C.store) +
      '&limit=1' +                       // producten staan op de zoekpagina, niet in de dropdown
      '&collections=5' +                 // alleen om suggesties aan te vullen met categorienamen
      '&queries=' + (C.queries || 8);
  }

  // ---------------------------------------------------------------- inhaken op HYPER
  function patch(PS) {
    var proto = PS.prototype;
    if (proto.__fkSearch) return;
    proto.__fkSearch = true;
    var original = proto.renderSectionFromFetch;

    // renderSection() kiest tussen cache en fetch; wij nemen de fetch over
    proto.renderSectionFromFetch = function (url) {
      var el = this;
      var q = el.getQuery();
      var sectionId = window.FoxTheme && FoxTheme.utils ? FoxTheme.utils.getSectionId(el) : '';
      var target = document.getElementById('PredictiveSearchResults-' + sectionId);
      if (!q || !target || el.searchProductTypes && el.searchProductTypes.value) {
        return original.call(el, url);
      }
      var req = (el.__fkReq = (el.__fkReq || 0) + 1);
      el.setLoadingState(true);
      getJSON(suggestUrl(q), TIMEOUT)
        .then(function (data) {
          if (req !== el.__fkReq) return; // er is al verder getypt
          target.innerHTML = renderResults(data, q);
          el.searchContent && el.searchContent.classList.remove('hidden');
          if (el.isHeaderSearch && !document.body.classList.contains('search-open')) {
            document.body.classList.add('search-open');
            el.toggleNavButtonVisibility && el.toggleNavButtonVisibility(true);
          }
          el.classList.add('predictive-search-open');
          el.setLoadingState(false);
        })
        .catch(function () {
          if (req !== el.__fkReq) return;
          el.setLoadingState(false);
          original.call(el, url); // terugval: gewone Shopify-dropdown
        });
    };
  }

  customElements.whenDefined('predictive-search').then(function () {
    patch(customElements.get('predictive-search'));
  });

  // ---------------------------------------------------------------- zoekpagina
  // Eén zoekbalk (zoals Temu): de balk van de zoekpagina zelf gaat weg (CSS op html.fk-one-bar),
  // de zoekterm komt in de balk in de header te staan.
  function oneSearchBar(q) {
    document.documentElement.classList.add('fk-one-bar');
    var input = document.querySelector('.header-section predictive-search input[type="search"]') ||
      Array.prototype.filter.call(document.querySelectorAll('predictive-search input[type="search"]'), function (i) {
        return !i.closest('.template-search');
      })[0];
    if (input && !input.value) input.value = q;
  }

  // Neemt /search over: categorieën → verfijnen → producten in onze volgorde. De kaarten zelf
  // rendert Shopify (sections/fk-search-cards.liquid), zodat prijs per market e.d. klopt.
  //
  // Filters en sortering: HYPER's filterdrawer blijft zoals hij is (opmaak, vinkjes, prijsschuif,
  // gekozen filters). Kiest de klant iets, dan laat HYPER Shopify zijn deel renderen; daarna
  // vervangen wij de producten, het aantal en de aantallen per optie door die uit onze index.
  // De URL-parameters zijn die van Shopify (filter.p.vendor=…, sort_by=…), dus een gedeelde link
  // werkt ook zonder ons. Bij een fout of time-out blijft Shopify's resultaat staan.
  var FILTER_KEYS = /^(filter\.|sort_by$)/;

  function searchPage() {
    var wrapper = document.getElementById('ProductGridWrapper');
    // HYPER kan de container bij een filterwijziging vervangen: altijd opnieuw opzoeken
    function gc() { return document.getElementById('ProductGridContainer'); }
    if (!document.querySelector('.template-search') || !wrapper || !gc()) return done();
    var q = (new URLSearchParams(location.search).get('q') || '').trim();
    oneSearchBar(q);
    if (q.length < 2) return done();

    // Aantal per keer (API max. 60). Shopify rendert max. 20 producten per sectie-aanvraag,
    // dus de kaarten komen in stukken van 20 (tegelijk opgehaald, in onze volgorde).
    var per = Math.min(60, C.pageSize || 50);
    var CARD_CHUNK = 20;
    // ownGrid: wij beheren de productlijst (na de eerste geslaagde keer); HYPER werkt dan bij een
    // filterwijziging alleen nog de drawer, pilletjes en sortering bij, niet de producten.
    var state = { page: 1, shown: 0, total: 0, filters: '', run: 0, ownGrid: false, facets: null };
    var topDone = false;
    addHistory(q);

    function done() { document.documentElement.classList.remove('fk-search-pending'); }

    // Filter- en sorteerparameters uit een URL (zoals Shopify ze zet), als querystring-deel
    function filterQuery(url) {
      var out = [];
      new URL(url, location.href).searchParams.forEach(function (v, k) {
        if (FILTER_KEYS.test(k) && v !== '') out.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
      return out.join('&');
    }

    function apiUrl(p) {
      return C.endpoint + '/search?q=' + encodeURIComponent(q) +
        '&locale=' + encodeURIComponent(C.locale) + '&country=' + encodeURIComponent(C.country || '') +
        '&store=' + encodeURIComponent(C.store) + '&page=' + p + '&per=' + per +
        '&collections=' + (C.pageCollections || 8) + '&queries=' + (C.pageQueries || 8) +
        (state.filters ? '&' + state.filters : '');
    }

    function fetchCardChunk(handles) {
      var url = base() + '/search?q=' + encodeURIComponent(handles.join(' ')) + '&section_id=fk-search-cards';
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        var box = new DOMParser().parseFromString(html, 'text/html').getElementById('FkSearchCards');
        if (!box) throw new Error('kaarten ontbreken');
        return Array.prototype.slice.call(box.children);
      });
    }

    function fetchCards(products) {
      var handles = (products || []).map(function (p) { return p.handle; }).filter(Boolean);
      var chunks = [];
      for (var i = 0; i < handles.length; i += CARD_CHUNK) chunks.push(handles.slice(i, i + CARD_CHUNK));
      return Promise.all(chunks.map(fetchCardChunk)).then(function (parts) {
        return [].concat.apply([], parts);
      });
    }

    function load(p) {
      return getJSON(apiUrl(p), C.pageTimeout || 2500).then(function (data) {
        return fetchCards(data.products).then(function (cards) { return { data: data, cards: cards }; });
      });
    }

    function grid() {
      var list = document.getElementById('ProductsList');
      if (!list) {
        list = document.createElement('div');
        list.id = 'ProductsList';
        list.className = 'grid-list products-list f-grid f-grid--gap-medium f-grid--row-gap-large';
        list.style.cssText = '--f-columns-mobile: 2; --f-columns-md: 3; --f-columns-xl: 4;';
        gc().insertBefore(list, gc().firstChild);
      }
      return list;
    }

    // Meteen ruimte maken voor categorieën + verfijnen (grijze placeholders), zodat de pagina niet
    // verspringt als ze binnenkomen
    function placeholderTop() {
      var top = document.createElement('div');
      top.className = 'fk-search-top fk-search-top--loading';
      var chips = '';
      [7, 9, 6, 8, 10, 7].forEach(function (w) { chips += '<li><span class="fk-skeleton" style="width:' + w + 'rem"></span></li>'; });
      top.innerHTML = '<div><h4 class="h6">' + esc(L.collections) + '</h4><ul class="ps-chips">' + chips + '</ul></div>' +
        '<div><h4 class="h6">' + esc(L.related) + '</h4><ul class="ps-chips">' + chips.slice(0, chips.length / 2) + '</ul></div>' +
        productsTitle();
      placeTop(top);
    }

    // Kopje "Producten" boven de filterbalk, om de producten te scheiden van categorieën/verfijnen
    function productsTitle() {
      return '<h4 class="h6 fk-products-title">' + esc(L.products) + '</h4>';
    }

    function placeTop(top) {
      var old = document.querySelector('.fk-search-top');
      if (old) { old.replaceWith(top); return; }
      // Boven de filterbalk (aantal, filter, weergave); anders bovenaan de resultaten
      var toolbar = document.querySelector('.template-search .sticky-element');
      if (toolbar && toolbar.parentNode) {
        toolbar.parentNode.insertBefore(top, toolbar);
      } else {
        wrapper.insertBefore(top, wrapper.firstChild);
      }
    }

    function renderTop(data) {
      var html = '';
      var cols = data.collections || [];
      var colNames = {};
      cols.forEach(function (c) { colNames[norm(c.title)] = true; });
      // Verfijnen: geen herhaling van de categorieën hierboven
      var rel = (data.queries || []).filter(function (x) { return x.query !== norm(q) && !colNames[x.query]; });
      if (cols.length) {
        html += '<div class="fk-search-top__collections"><h4 class="h6">' + esc(L.collections) + '</h4><ul class="ps-collections" role="list">';
        cols.forEach(function (c) {
          html += '<li><a href="' + esc(base() + '/collections/' + c.handle) + '" class="ps-collection reversed-link--icon-only">' +
            '<span class="ps-collection__media">' + (c.image ? '<img src="' + esc(c.image) + '" alt="' + esc(c.title) +
            '" width="60" height="60" loading="lazy">' : '') + '</span><span class="ps-collection__title">' + esc(c.title) +
            '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (rel.length) {
        html += '<div class="fk-related flex flex-col gap-3"><h4 class="h6">' + esc(L.related) + '</h4><ul class="ps-chips">' +
          rel.map(function (x) { return chip(x.query, x.label, inHistory(x.query)); }).join('') + '</ul></div>';
      }
      var old = document.querySelector('.fk-search-top');
      if (!html) { if (old) old.remove(); return; }
      var top = document.createElement('div');
      top.className = 'fk-search-top';
      top.innerHTML = html + productsTitle();
      placeTop(top);
    }

    // Prijsschuif: hoogste prijs uit ons resultaat in plaats van die van Shopify
    function renderPrice(price) {
      if (!price || !(price.max > 0)) return;
      var max = Math.ceil(price.max);
      Array.prototype.forEach.call(document.querySelectorAll('price-range'), function (range) {
        var inputs = range.querySelectorAll('input[type="range"]');
        var maxInput = range.querySelector('input[name="filter.v.price.lte"]');
        var minInput = range.querySelector('input[name="filter.v.price.gte"]');
        Array.prototype.forEach.call(inputs, function (input) { input.max = max; });
        if (inputs[1] && (!maxInput || maxInput.value === '' || +inputs[1].value > max)) inputs[1].value = max;
        if (maxInput) { maxInput.max = max; maxInput.placeholder = max; }
        if (minInput) minInput.max = max;
        var wrap = inputs[0] && inputs[0].parentElement;
        if (wrap) {
          wrap.style.setProperty('--range-min', (Math.min(+inputs[0].value, max) / max * 100) + '%');
          wrap.style.setProperty('--range-max', (Math.min(+(inputs[1] || {}).value || max, max) / max * 100) + '%');
        }
        // "De hoogste prijs is €191,95": het bedrag vervangen, de tekst (en taal) van de theme houden
        var text = range.querySelector('.text-subtext');
        if (text) text.textContent = text.textContent.replace(/[\d.,]+(?=\D*$)/, price.max.toFixed(2).replace('.', ','));
      });
    }

    // Aantallen per filteroptie uit onze index. Zonder resultaat: weg; aangevinkt maar 0: grijs,
    // zodat de klant ziet wat hij koos (weghalen via het vinkje of het pilletje).
    // Let op: HYPER zet "flex" op de <li>, dus het hidden-attribuut werkt niet; daarom klassen + CSS.
    function renderFacets(facets) {
      if (!facets) return;
      renderPrice(facets.price);
      Object.keys(facets).forEach(function (param) {
        if (param === 'price') return;
        var counts = facets[param] || {};
        var inputs = document.querySelectorAll('input[type="checkbox"][name="' + param + '"]');
        Array.prototype.forEach.call(inputs, function (input) {
          var n = counts[input.value] || 0;
          var li = input.closest('li') || input.parentElement;
          var count = li && li.querySelector('.count');
          if (count) count.textContent = n;
          if (li) {
            li.classList.toggle('fk-facet-zero', n === 0 && !input.checked);
            li.classList.toggle('fk-facet-zero-checked', n === 0 && input.checked);
          }
        });
        // Hele groep weg als er niets te kiezen valt (zoals Shopify ook doet)
        Array.prototype.forEach.call(document.querySelectorAll('[data-filter]'), function (group) {
          if (!group.querySelector('input[type="checkbox"][name="' + param + '"]')) return;
          var visible = group.querySelectorAll('input[type="checkbox"][name="' + param + '"]');
          var any = Array.prototype.some.call(visible, function (i) { var li = i.closest('li'); return !li || !li.classList.contains('fk-facet-zero'); });
          group.classList.toggle('fk-facet-empty', !any);
        });
      });
    }

    function updateCount() {
      var el = document.getElementById('ProductCount');
      if (el) el.textContent = L.results.replace('%n', state.total);
      // Paginatitel ("Zoeken: 947 resultaten gevonden voor …") met ons aantal
      // Alleen vóór de zoekterm (tussen aanhalingstekens) en niet de 365 uit de winkelnaam
      var t = document.title.match(/^([^'"‘“„«]*?)\b\d[\d.,]*(?=\s)/);
      if (t) document.title = t[1] + state.total + document.title.slice(t[0].length);
      var more = gc().querySelector('.fk-more');
      if (!more) return;
      more.querySelector('.fk-more__count').textContent = state.total ? L.shown.replace('%a', state.shown).replace('%b', state.total) : '';
      more.querySelector('button').hidden = state.shown >= Math.min(state.total, state.browsable || state.total);
    }

    function setupMore() {
      // Paginering en "geen resultaten" van Shopify weg, eigen knop eronder
      Array.prototype.slice.call(gc().children).forEach(function (child) {
        if (child.id !== 'ProductsList') child.remove();
      });
      var more = document.createElement('div');
      more.className = 'fk-more flex flex-col items-center gap-3';
      more.innerHTML = '<p class="fk-more__empty m-0" hidden>' + esc(L.noFilterResults) + '</p>' +
        '<p class="fk-more__count m-0 text-subtext"></p>' +
        '<button type="button" class="btn btn--secondary">' + esc(L.more) + '</button>';
      gc().appendChild(more);
      var button = more.querySelector('button');
      var run = state.run;
      button.addEventListener('click', function () {
        button.disabled = true;
        load(state.page + 1).then(function (res) {
          if (run !== state.run) return; // intussen ander filter gekozen
          state.page++;
          res.cards.forEach(function (card) { grid().appendChild(card); });
          state.shown += res.cards.length;
          button.disabled = false;
          updateCount();
        }).catch(function () { button.disabled = false; });
      });
    }

    // Eén keer laden en tonen; first = eerste keer op de pagina (zonder filter: Shopify bij 0 resultaten)
    function show(first, preloaded) {
      var run = preloaded ? state.run : ++state.run;
      return (preloaded || load(1)).then(function (res) {
        if (run !== state.run) return;
        var total = res.data.total || 0;
        if (first && !total && !state.filters) { // niets gevonden: Shopify laat zijn resultaat zien
          var ph = document.querySelector('.fk-search-top--loading');
          if (ph) ph.remove();
          return done();
        }
        if (total && !res.cards.length) return done(); // kaarten niet te laden: Shopify laten staan
        state.page = 1;
        state.total = total;
        state.browsable = res.data.browsable || total; // zoveel kun je doorbladeren (max. 5000)
        state.shown = res.cards.length;
        var list = grid();
        list.innerHTML = '';
        res.cards.forEach(function (card) { list.appendChild(card); });
        // Shopify vond niets (bv. een artikelnummer als "504230") maar wij wel: "Geen resultaten" weg
        // (HYPER zet "grid" op dat blok, dus hidden werkt niet: display) en zelf een aantal tonen,
        // want zonder resultaten rendert HYPER geen filterbalk met #ProductCount.
        var empty = document.querySelector('.template-search__header .text-center.grid');
        if (empty && total) empty.style.display = 'none';
        if (total && !document.getElementById('ProductCount')) {
          var count = document.createElement('p');
          count.id = 'ProductCount';
          count.className = 'fk-count text-subtext';
          wrapper.insertBefore(count, wrapper.firstChild);
        }
        if (!topDone) { renderTop(res.data); topDone = true; }
        list.classList.remove('fk-fade');
        void list.offsetWidth; // animatie opnieuw starten
        list.classList.add('fk-fade');
        setupMore();
        gc().querySelector('.fk-more__empty').hidden = total > 0;
        state.facets = res.data.facets;
        renderFacets(state.facets);
        updateCount();
        state.ownGrid = true;
        done();
      }).catch(function () {
        if (run !== state.run) return;
        var ph = document.querySelector('.fk-search-top--loading');
        if (ph) ph.remove();
        // Fout: Shopify's resultaat tonen (als HYPER dat al binnen heeft, nu; anders zodra het komt)
        state.ownGrid = false;
        if (state.shopifyGrid) state.shopifyGrid();
        done();
      });
    }

    // HYPER: elke filter- of sorteerwijziging gaat via FacetForm.renderSection(url). Wij halen
    // meteen (tegelijk met Shopify) onze resultaten op en tonen ze zodra ze er zijn. HYPER's eigen
    // rendering van de productlijst en het aantal slaan we over (geen Shopify-producten tussendoor);
    // de drawer, pilletjes en sortering laat HYPER wel bijwerken, daarna zetten we onze aantallen terug.
    customElements.whenDefined('facet-form').then(function () {
      var FacetForm = customElements.get('facet-form');
      if (!FacetForm || FacetForm.prototype.__fkSearch) return;
      var proto = FacetForm.prototype;
      proto.__fkSearch = true;
      var renderSection = proto.renderSection;
      var renderGrid = proto.renderProductGridContainer;
      var renderCount = proto.renderProductCount;
      proto.renderSection = function (url, event) {
        state.shopifyGrid = null;
        if (!state.ownGrid) return renderSection.call(this, url, event);
        state.filters = filterQuery(url);
        document.documentElement.classList.add('fk-search-pending');
        setTimeout(done, 4000); // vangnet
        show(false);
        return renderSection.call(this, url, event);
      };
      proto.renderProductGridContainer = function (responseText) {
        var form = this;
        if (!state.ownGrid) return renderGrid.call(form, responseText);
        // Bewaren voor als onze aanvraag alsnog mislukt
        state.shopifyGrid = function () {
          renderGrid.call(form, responseText);
          renderCount && renderCount.call(form, responseText);
        };
      };
      proto.renderProductCount = function (responseText) {
        if (!state.ownGrid) return renderCount.call(this, responseText);
      };
      // HYPER maakt de productlijst onzichtbaar tot zijn eigen fetch klaar is en animeert hem daarna
      // opnieuw in. Wij tonen eerder: zonder die animaties, wel scrollen en de laad-spinner.
      var before = proto.beforeRenderSection;
      var after = proto.afterRenderSection;
      proto.beforeRenderSection = function () {
        if (!state.ownGrid) return before.call(this);
        setTimeout(function () {
          var target = document.querySelector('.collection');
          if (target) {
            window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 200,
              behavior: window.FoxTheme && FoxTheme.config && FoxTheme.config.motionReduced ? 'auto' : 'smooth' });
          }
          Array.prototype.forEach.call(document.querySelectorAll('[data-facet-loading]'), function (el) { el.classList.add('btn--loading'); });
        }, 100);
      };
      proto.afterRenderSection = function () {
        if (!state.ownGrid) return after.call(this);
        Array.prototype.forEach.call(document.querySelectorAll('[data-facet-loading]'), function (el) { el.classList.remove('btn--loading'); });
        document.dispatchEvent(new CustomEvent('collection:rerendered'));
      };
    });
    // Na HYPER's render: zijn aantallen in de drawer weer vervangen door de onze
    document.addEventListener('collection:rerendered', function () {
      if (state.ownGrid && state.facets) renderFacets(state.facets);
    });

    state.filters = filterQuery(location.href);
    if (!document.querySelector('.fk-search-top')) placeholderTop();
    show(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', searchPage);
  } else {
    searchPage();
  }

  // Leeg zoekveld: recent + populair (onFocus is in de constructor al gebonden, dus eigen listener)
  document.addEventListener('focusin', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('predictive-search input[type="search"]')) return;
    var el = input.closest('predictive-search');
    if (el) fillDefault(el);
  });
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('predictive-search input[type="search"]') && input.value.trim() === '') {
      var el = input.closest('predictive-search');
      if (el) fillDefault(el);
    }
  });

  // Geschiedenis bijhouden: zoeken (Enter / knop), klik op een suggestie of chip, klik op een resultaat
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('predictive-search')) return;
    var input = form.querySelector('input[name="q"]');
    if (input) addHistory(input.value);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.fk-recent__clear')) {
      e.preventDefault();
      clearHistory();
      var el = e.target.closest('predictive-search');
      if (el) fillDefault(el);
      return;
    }
    var a = e.target.closest && e.target.closest('predictive-search a[href]');
    if (!a) return;
    if (a.dataset.fkQuery) {
      addHistory(a.dataset.fkQuery);
      return;
    }
    var el2 = a.closest('predictive-search');
    var input = el2 && el2.querySelector('input[type="search"]');
    if (input && input.value.trim()) addHistory(input.value);
  }, true);
})();
